// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/account/web/6053/js/" + chunkId + ".chunk.js";
};